import clsx from 'clsx'
import { FC, ReactNode } from 'react'

import { Question } from '@/shared/lib/@deprecated/iport-icons'
import { Button, Popover } from '@/shared/ui'

import cls from './CreditItem.module.scss'

interface CreditItemProps {
	/** Period display text (e.g., "12 мес.", "до 36 мес.") */
	period: string
	/** Payment amount display text (e.g., "от 1200 руб./мес.") */
	payCount: string
	/** First payment amount */
	firstPay: number | string
	/** Callback when user clicks apply button */
	onApply: () => void
	/** Show separator line below item */
	withSeparate?: boolean
	/** Custom footer content */
	footerNode?: ReactNode
	/** Show Vsegdada specific tooltip */
	isVsegdada?: boolean
}

const VSEGDADA_DESCRIPTION = `Ставка от 9.28% до 21.6% (рассрочка предоставляется с небольшим удорожанием, за счёт скидки продавца от 3.5% до 12% от стоимости товара. Общая сумма переплаты за рассрочку может составлять от 1% до 10%, в зависимости от предложения`

/**
 * Credit/Installment item display component
 * Presentational component that displays payment terms and calls callback on action
 */
export const CreditItem: FC<CreditItemProps> = ({
	period,
	payCount,
	firstPay,
	onApply,
	withSeparate,
	footerNode,
	isVsegdada
}) => {
	return (
		<div className={clsx(cls.creditContentTab, withSeparate && cls.creditContentTab_withSeparate)}>
			<div className={cls.creditContentTab__infoItem}>
				<span>Срок</span>
				<span>{period}</span>
			</div>
			<div className={cls.creditContentTab__infoItem}>
				<span>Платеж</span>
				<span>
					{payCount}
					{isVsegdada && (
						<Popover placement={'bottom'} content={VSEGDADA_DESCRIPTION}>
							<Question size={24} fill={'none'} />
						</Popover>
					)}
				</span>
			</div>
			<div className={cls.creditContentTab__infoItem}>
				<span>Первый взнос</span>
				<span>{firstPay}</span>
			</div>
			<div className={cls.creditContentTab__buttonWrap}>
				<Button size="M" onClick={onApply}>
					Оформить
				</Button>
			</div>
			{footerNode && <div className={cls.creditContentTab__footerNode}>{footerNode}</div>}
		</div>
	)
}
